import {StorageService} from './abstract-storage.service';

/**
 * Предоставляет возможность создавать сохраняемые объекты в хранилище данных (localStorage, sessionStorage и пр.).
 * Сохраняемый объект должнен быть обязательно помечен с использованием @Savable.key('yourObjKey'),
 * а свойства - @Savable.property, например:
 *
 * @Savable.key('MySavableObj')
 * class MySavableObj extends Savable {
 *
 *     @Savable.property
 *     sampleProperty: number = 42;
 *
 *     nonSavable: string;
 *
 *     constructor(...) { ... }
 *
 *     action() {
 *         if (this.nonSavable === 'saveNow') {
 *             this.save();
 *         }
 *     }
 * }
 *
 */
export abstract class Savable {

    private _notified: number;

    private _data: Object = {};

    private _key: string;

    static boolean(restoredValue: boolean, defaultValue: boolean): boolean {
        return typeof restoredValue === 'boolean' ? restoredValue : defaultValue;
    }

    static key(key: string) {
        return function (target) {
            target.prototype._key = key;
        };
    }

    static property(target: Savable, key: string) {
        if (delete target[key]) {
            Object.defineProperty(target, key, {
                configurable: false,
                enumerable: true,
                get: function () {
                    return this._data[key];
                },
                set: function (value) {
                    this._data[key] = value;
                    this.save();
                }
            });
        }
    }

    constructor(protected storage: StorageService) {
    }

    protected remove(): void {
        this.storage.remove(this._key);
    }

    protected restore(): any {
        return this.storage.getJson(this._key) || {};
    }

    protected save(): void {
        if (!this._notified) {
            this._notified = setTimeout(() => {
                this._notified = null;
                this.storage.setJson(this._key, this._data);
            });
        }
    }

}